import Cereali from "./img/Cereali";
import Crostacei from "./img/Crostacei";
import Uova from "./img/Uova";
import Pesce from "./img/Pesce";
import Arachidi from "./img/Arachidi";
import Soia from "./img/Soia";
import Latte from "./img/Latte";
import FruttaGuscio from "./img/FruttaGuscio";
import Sedano from "./img/Sedano";
import Senape from "./img/Senape";
import SemiSesamo from "./img/SemiSesamo";
import AnidrideSolforosaSolfiti from "./img/AnidrideSolforosaSolfiti";
import Lupini from "./img/Lupini";
import Molluschi from "./img/Molluschi";

export default function Allergens({
	allergens,
	color = "red",
	backgroundColor = "pink",
	lang,
	iconsOnly = false,
}) {
	const getTranslations = (allergen) => {
		let name = allergen.name;
		if (allergen.translations && lang == "en") name = allergen.translations.en;
		if (allergen.translations && lang == "zh") name = allergen.translations.zh;
		if (allergen.translations && lang == "fr") name = allergen.translations.fr;
		if (allergen.translations && lang == "es") name = allergen.translations.es;
		if (allergen.translations && lang == "de") name = allergen.translations.de;
		return name;
	};

	return (
		<>
			{allergens.map((allergen, i) => (
				<div key={i}>
					<div
						className="img"
						style={{ backgroundColor: backgroundColor }}
						title={getTranslations(allergen)}
					>
						{allergen.id == 1 && <Cereali color={color} />}
						{allergen.id == 2 && <Crostacei color={color} />}
						{allergen.id == 3 && <Uova color={color} />}
						{allergen.id == 4 && <Pesce color={color} />}
						{allergen.id == 5 && <Arachidi color={color} />}
						{allergen.id == 6 && <Soia color={color} />}
						{allergen.id == 7 && <Latte color={color} />}
						{allergen.id == 8 && <FruttaGuscio color={color} />}
						{allergen.id == 9 && <Sedano color={color} />}
						{allergen.id == 10 && <Senape color={color} />}
						{allergen.id == 11 && <SemiSesamo color={color} />}
						{allergen.id == 12 && <AnidrideSolforosaSolfiti color={color} />}
						{allergen.id == 13 && <Lupini color={color} />}
						{allergen.id == 14 && <Molluschi color={color} />}
					</div>
					{!iconsOnly && <div>{getTranslations(allergen)}</div>}
				</div>
			))}
		</>
	);
}
